/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ArtboardIcon = ({ width = 24, height = 24, hidden = false, title = 'Artboard' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M8 9v24a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V14.914a1 1 0 0 0-.293-.707l-5.914-5.914A1 1 0 0 0 27.086 8H9a1 1 0 0 0-1 1Zm24 23H10V10h16v5a1 1 0 0 0 1 1h5ZM8 0h2v6H8zM0 8h6v2H0z"
    />
  </svg>`;
};
